import { jwtDecode } from "jwt-decode";
import { api } from "./api";
import axios from "axios";
import { userSetter } from "../utils/Redux/Slice/User/Index";

export const checkIfLoggedIn = async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const user = jwtDecode(token);
      const res = await axios.get(`${api}auth/show/${user.id}`);

      if (user && res.status === 200) {
        dispatch(userSetter(res.data.results));
        return true;
      }
    } catch (error) {
      console.error("Auth check failed:", error);
    }
    return false;
  }
  return false;
};

export const checkUserRole = () => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const user = jwtDecode(token);
      return user?.role || false;
    } catch {
      return false;
    }
  }
  return false;
};
// import { jwtDecode } from "jwt-decode";
// import {api} from './api'
// import axios from 'axios'
// import { useDispatch } from 'react-redux'
// import { userSetter } from '../utils/Redux/Slice/User/Index'

// export const checkIfLoggedIn =async () => {
//     const token = localStorage.getItem("token");
//     if (token) {
//         const dispatch = useDispatch()
//         const user = jwt_decode(token);
//         // if (user.role === 'super_admin') {
//         //     return ({ role: user.role })
//         // }
//        const res =  await axios.get(`${api}auth/show/${user.id}`)
//         if (user && res.status === 200) {
//             dispatch(userSetter(res.data.results))
//             return true
//         }
//         return false
//     }
//     return false
// }

// export const checkUserRole = () => {
//     const token = localStorage.getItem("token");
//     if (token) {
//         const user = jwt_decode(token);
//         if (user) {
//             return user.role
//         }
//         return false
//     }
//     return false
// }